import React from 'react';
import { Modal } from './Modal';
import { CreateListForm } from './CreateListForm';
import { EditListForm } from './EditListForm';
import { ListInfoDialog } from './ListInfoDialog';
import { PublicUrlCelebrationModal } from './PublicUrlCelebrationModal';
import { Check, Trash2, X } from 'lucide-react';
import { useListManagement } from '../hooks/useListManagement';

interface ListManagementModalsProps {
  listManagement: ReturnType<typeof useListManagement>;
}

export const ListManagementModals: React.FC<ListManagementModalsProps> = ({ 
  listManagement 
}) => {
  const {
    showCreateListForm,
    showEditListForm,
    showListInfoDialog,
    newPublicUrl,
    createListData,
    editListData,
    selectedList,
    createListMutation,
    updateListMutation,
    deleteListMutation,
    handleSaveCreate,
    handleSaveEdit,
    handleDeleteList,
    closeCreateForm,
    closeEditForm,
    closeListInfo,
    closeCelebrationModal,
    setCreateListData,
    setEditListData,
  } = listManagement;

  return (
    <>
      {/* Create List Modal */}
      <Modal
        isOpen={showCreateListForm}
        onClose={closeCreateForm}
        title="Create New List"
        hideCloseButton={true}
        actionButtons={
          <>
            <button
              type="button"
              onClick={handleSaveCreate}
              disabled={!createListData?.name.trim() || createListMutation.isPending}
              className="header-btn header-btn-save"
              title="Create list"
              aria-label="Create list"
            >
              <Check size={16} />
            </button>
            <button
              type="button"
              onClick={closeCreateForm}
              className="header-btn header-btn-close"
              title="Cancel"
              aria-label="Cancel"
            >
              <X size={16} />
            </button>
          </>
        }
      >
        <CreateListForm onSave={setCreateListData} />
      </Modal>

      {/* Edit List Modal */}
      {selectedList && (
        <Modal
          isOpen={showEditListForm}
          onClose={closeEditForm}
          title="Edit List"
          hideCloseButton={true}
          actionButtons={
            <>
              <button
                type="button"
                onClick={handleSaveEdit}
                disabled={!editListData?.name.trim() || updateListMutation.isPending}
                className="header-btn header-btn-save"
                title="Save changes"
                aria-label="Save changes"
              >
                <Check size={16} />
              </button>
              <button
                type="button"
                onClick={handleDeleteList}
                disabled={updateListMutation.isPending || deleteListMutation.isPending}
                className="header-btn header-btn-delete"
                title="Delete list"
                aria-label="Delete list"
              >
                <Trash2 size={16} />
              </button>
              <button
                type="button"
                onClick={closeEditForm}
                className="header-btn header-btn-close"
                title="Cancel"
                aria-label="Cancel"
              >
                <X size={16} />
              </button>
            </>
          }
        >
          <EditListForm
            list={selectedList}
            onSave={setEditListData}
            onClose={closeEditForm}
          />
        </Modal>
      )}

      {/* List Info Dialog for non-owners */}
      {selectedList && showListInfoDialog && (
        <ListInfoDialog
          list={selectedList}
          onClose={closeListInfo}
        />
      )}

      {/* Celebration Modal */}
      <PublicUrlCelebrationModal
        publicUrl={newPublicUrl}
        onClose={closeCelebrationModal}
      />
    </>
  );
};